module.exports = __webpack_public_path__ + "img/estimator_banner.a5b844f3.png";